import {
  CLEAR_PROGRAM_ENROLLMENT,
} from 'actions';

// TODO Delete since there isn't an enrollment entity anymore
export default function clearProgramEnrollment() {
  return (dispatch) => dispatch({ type: CLEAR_PROGRAM_ENROLLMENT });
}
